import React from 'react';
/* import { useSelector } from "react-redux";
import GetUserInfo from '../../User/Infrastructure/User.presenter';
import { getUserModel } from "../../User/Infrastructure/User.reducer"; */

export default function AdviserProfile() {
  /* const idUser = useSelector(getUserModel);

  useEffect(() => {
    GetUserInfo(idUser);
  }, []);
 */
  return(
    <div> <p>El perfil del asesor</p> </div>
  );
}